import { useState } from "react";
import { toast } from "sonner";
import { FileSpreadsheet, Loader2 } from "lucide-react";
import { billingLink, ron } from "@/lib/bf";

const today = () => new Date().toLocaleDateString("sv-SE", { timeZone: "Europe/Bucharest" });

export default function BFBilling() {
  const [day, setDay] = useState(today());
  const [busy, setBusy] = useState(false);
  const go = () => {
    setBusy(true);
    billingLink(day).then((r) => { if (!r.sheets) toast.info("În ziua aleasă nu există proforme. Fișierul va fi gol."); window.location.href = r.url; if (r.sheets) toast.success(`${r.sheets} proforme · ${ron(r.total)}`); })
      .catch(() => toast.error("Nu am putut pregăti Excelul")).finally(() => setBusy(false));
  };
  return (
    <section className="invite-box" data-testid="bfa-billing">
      <h3>Excel pentru facturare</h3>
      <p className="st-hint">Un singur fișier cu toate proformele zilei, câte o foaie pe proformă (max. 40 de linii, gata de import). Pleacă automat pe email la admini în fiecare seară la 20:00.</p>
      <div className="share-actions">
        <input type="date" value={day} max={today()} onChange={(e) => setDay(e.target.value)} className="bf-billing-date" data-testid="bf-billing-day" />
        <button type="button" className="st-btn st-btn--light" onClick={go} disabled={busy || !day} data-testid="bf-billing-download">
          {busy ? <Loader2 size={14} className="animate-spin" /> : <FileSpreadsheet size={14} />} Descarcă Excelul zilei
        </button>
      </div>
    </section>
  );
}
